<script setup>
import { ref } from 'vue';
import { ElCollapseItem, ElIcon, ElTooltip, ElButton } from 'element-plus';
import { Lock } from '@element-plus/icons-vue';
import { ArrowRightBold } from '@element-plus/icons-vue';
import { el } from 'element-plus/es/locale/index.mjs';
const props = defineProps(['title', 'name']);
const visible = ref(false);

const ctaHtml = `
    <div class="fpe-pro-cta">
        <h3>Upgrade now to unlock all the pro features</h3>
        
            <a href="https://wpvibes.link/go/fpe-feature-compare/" target="_blank" class="fpe-pro-feature-link">View Pro Features</a>
            <a class="fpe-pro-upgrade" href="https://wpvibes.link/go/fpe-pricing/" target="_blank">Upgrade to Pro</a>
    </div>
`;
</script>


<!-- <template>
    <el-tooltip
        class="box-item"
        effect="dark"
        content="Top Left prompts info"
        placement="top-start"
      >
        <el-button>top-start</el-button>
      </el-tooltip>
</template> -->
<template>
    <el-tooltip
        :content="ctaHtml"
        placement="left"
        trigger = "click"
        raw-content
        effect="light"
        popper-class="fpe-pro-upgrade-tooltip"
        >
        <el-collapse-item :title="title" class="fpe-dummy-item" :icon="Lock" :disabled="true">
            <template #title>
                <el-button type="" class="fpe-pro-title">{{ title }}</el-button>
            </template>
        </el-collapse-item>
    </el-tooltip>
</template>
    
    
    